<template>
  <transition>
  <div v-if="isShow" name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="close">
        <div id="content" @click.stop="">
          <h1 class="common__main-title">Upload Tutor Image</h1>
          <div class="d-flex justify-content-center">
            <ImgInputer
              v-model="userImage"
              theme="light"
              size="large"
              class="mb-5"
              placeholder="choose a file or drag it here."
              bottom-text="choose a file or drag it here."
              exceed-size-text="The size of file should less than: "
            />
          </div>
          <div class="d-flex justify-content-center">
          <b-button
            pill
            variant="primary"
            @click="upload"
          >
            <span v-show="!isLoading">upload</span>
            <font-awesome-icon v-show="isLoading" icon="spinner" spin />
          </b-button>
          </div>
          <span class="chancel-button" @click="close">
            <font-awesome-icon  icon="times"/>
          </span>
        </div>
      </div>
    </div>
  </div>
  </transition>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
// @ts-expect-error 型チェック不要部分
import ImgInputer from 'vue-img-inputer'
import 'vue-img-inputer/dist/index.css'

@Component({
  components: {
    ImgInputer,
  },
})
export default class UploadTutorProfileImageModal extends Vue {
  private isShow: boolean = false

  private isLoading: boolean = false

  private userImage: File|null = null

  /**
   * モーダルを開く
   */
  public open(): void {
    this.isShow = true
    this.isLoading = false
  }

  /**
   * モーダルを閉じる
   */
  public close(): void {
    this.isShow = false
  }

  /**
   * 画像アップロード処理
   * @emits success アップロード成功時
   * @emits error アップロード失敗時
   */
  public upload(): void {
    if (!this.userImage || this.isLoading) {
      return
    }

    this.isLoading = true
    this.$store.dispatch('fetchTutorImage', {
      tutorId: this.$route.params.id,
      userImage: this.userImage,
    })
      .then(() => {
        this.$emit('success')
      })
      .catch((error) => {
        this.$emit('error', error)
      })
      .finally(() => {
        this.isLoading = false
      })
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

#content{
  z-index:2;
  width:50%;
  text-align: center;
  padding: 2em;
  margin: 0 auto;
  background:#fff;
  border-radius: 10px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.chancel-button {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
  line-height: 20px;
  font-size: 20px;
}

.chancel-button:hover {
  opacity:.5;
}

.tutor-img {
  width: 120px;
  height:120px;
  background: #ACB8CA;
  background-size: cover;
  background-position: center;
  text-align: center;
  border-radius: 200px;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
